import React, { useState } from "react";
import { TopBanner } from "./TopBanner";
import { MenuToggle } from "./components/MenuToggle";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { buildZedXMainAppBreadcrumb } from "./breadcrumbs";
import { Routes, Route } from "react-router-dom";
import { DemoZedXMainMenu } from "./components/DemoZedXMainMenu";
import { DemoCustomerAccessPanel } from "./components/account/DemoCustomerAccessPanel";

export const DemoHome: React.FC = () => {

    const [isNavigationVisible, setNavigationVisible] = useState(false);
    const toggleNavigation = () => setNavigationVisible(!isNavigationVisible);

    const breadcrumbItems = buildZedXMainAppBreadcrumb();

    return (
        <ErrorBoundary>
            <div className="main">
                <div className="container">

                    {/* LEFT NAV */}
                    <div className={`navigation ${isNavigationVisible ? 'show' : ''}`}>
                        <DemoZedXMainMenu
                            onCloseMenu={() => setNavigationVisible(false)}
                        />
                    </div>

                    {/* BACKDROP */}
                    <div
                        className={`nav-backdrop ${isNavigationVisible ? 'show' : ''}`}
                        onClick={toggleNavigation}
                    />

                    {/* RIGHT */}
                    <div className="right-area">
                        <div className="top-banner">
                            <MenuToggle onToggleNavigation={toggleNavigation} />
                            <TopBanner breadcrumbItems={breadcrumbItems} />
                        </div>

                        <div className="content">
                            <Routes>
                                <Route
                                    path="/"
                                    element={<DemoCustomerAccessPanel />}
                                />
                            </Routes>
                        </div>
                    </div>

                </div>
            </div>
        </ErrorBoundary>
    );
};